<template>
  <vx-card no-shadow>
    <div class="vx-row mb-6">
      <vs-alert v-if="error_message" color="warning">{{
        error_message
      }}</vs-alert>
    </div>
    <br />
    <form @submit.prevent="onSubmit" id="account-manage-buttons">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Old Password</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="'required'"
            name="Old Password"
            class="w-full"
            v-model="old_password"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Old Password')"
            >{{ errors.first("Old Password") }}</span
          >
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>New Password</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="'required|min:6'"
            name="Password"
            class="w-full"
            v-model="password"
          />
          <span class="text-danger text-sm" v-show="errors.has('Password')">{{
            errors.first("Password")
          }}</span>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        <vs-button
          class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
          button="submit"
          >Change Password</vs-button
        >
      </div>
    </form>
  </vx-card>
</template>

<script>
import axios from '../../../axios'
import axios120 from '../../../axios120'
export default {
  data() {
    return {
      old_password: '',
      password: '',
      error_message: null
    }
  },
  methods: {

    onSubmit() {
      const formData = {
        old_password: this.old_password,
        password: this.password,
        confirm_new_password: this.confirm_new_password
      }

      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#account-manage-buttons",
        scale: 0.45
      })
      this.$validator.validateAll().then(result => {
        if (result) {
          axios120.post('ecommerce/web/auth/changePassword', formData)
            .then(res => {

              console.log(res)
              this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
              this.acceptAlert('success', 'Berhasil', 'Anda berhasil rubah password, silahkan login ulang')
              this.error_message = null
              this.$store.dispatch('logout')

              this.$router.push('/pages/login').catch(() => { })




            })
            .catch(error => {
              console.log(error.response)
              this.error_message = error.response.data.message
              this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
              this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')
            })
        } else {
          this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
        }
      })


    },
    acceptAlert(color, title, message) {

      this.$vs.notify({
        color,
        title,
        text: message
      })

    },

  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  }
}
</script>
